import { put, call } from 'redux-saga/effects';
import ActionTypes from '@ziynx/action-types';
import type { DiscoverType } from '@ziynx/flow-types/discover';
import type { ChannelType } from '@ziynx/flow-types/channel';

type GetChannelResponse = {
  _id: string,
  name: string, // section title
  isLastPage: boolean,
  page: number,
  pageSize: number,
  total: number,
  results: Array<ChannelType>
};

type GetChannelAction = {
  id: string,
  type: string,
  body?: {
    hint?: {
      timestamp?: number,
      skipCache?: boolean,
      viewedCount?: number,
    }
  }
};

type GetWatchlistAction= {
  id?: string,
  type: string,
  page?: number,
};

type RemoveFromWatchlistAction = {
  type: string,
  talentId: string,
  body?: {
    userId?: string,
  }
};

type AddToWatchlistAction = {
  type: string,
  talentId: string,
  body?: {
    userId?: string,
  },
  userInfo?: Object,
};

type PostFiltersAction = {
  type: string,
  filters?: {
    [filterCategory: string]: Array<string>
  }
};

export function* getDiscover(action: PostFiltersAction): Generator<any, void, empty> {
  try {
    const response: DiscoverType = yield call(() => APIService.apiRequest('GET_DISCOVER', 'POST', {
      body: { filters: action?.filters },
    }));

    yield put({
      type: ActionTypes.discover.get.SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.discover.get.ERROR,
      error,
    });
  }
}

export function* getChannel(action: GetChannelAction): Generator<any, void, empty> {
  try {
    const response: GetChannelResponse = yield call(() => APIService.apiRequest('GET_CHANNEL', 'POST', {
      routeParams: {
        channelId: action?.id,
      },
      body: action?.body ?? {},
    }));

    yield put({
      type: ActionTypes.discover.getChannel.SUCCESS,
      id: action?.id,
      isFirstPage: !action?.body?.hint, // To signal reducer to concat results or not
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.discover.getChannel.ERROR,
      id: action?.id,
      error,
    });
  }
}

export function* getWatchlist(action: GetWatchlistAction): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('GET_WATCHLIST', 'GET', {
      routeParams: {
        id: action?.id ?? 'me',
      },
      query: {
        pageSize: 10,
        page: action?.page ?? 0,
      },
    }));

    yield put({
      type: ActionTypes.watchlist.get.SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.watchlist.get.ERROR,
      error,
    });
  }
}

export function* addToWatchlist(action: AddToWatchlistAction): Generator<any, void, empty> {
  try {
    yield call(() => APIService.apiRequest('ADD_TO_WATCHLIST', 'POST', {
      body: action?.body ?? {},
    }));

    yield put({
      type: ActionTypes.watchlist.add.SUCCESS,
      userInfo: action?.userInfo,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.watchlist.add.ERROR,
      userInfo: action?.userInfo,
      error,
    });
  }
}

export function* removeFromWatchlist(
  action: RemoveFromWatchlistAction,
): Generator<any, void, empty> {
  // RETURN UPDATED WATCHLIST
  try {
    const response = yield call(() => APIService.apiRequest('REMOVE_FROM_WATCHLIST', 'DELETE', {
      body: action?.body ?? {},
    }));

    yield put({
      type: ActionTypes.watchlist.remove.SUCCESS,
      userInfo: action?.userInfo,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.watchlist.remove.ERROR,
      userInfo: action?.userInfo,
      error,
    });
  }
}

export function* postFilters(action: PostFiltersAction): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('GET_DISCOVER', 'POST', {
      body: { filters: action?.filters },
    }));

    yield put({
      type: ActionTypes.discover.postFilters.SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.discover.postFilters.ERROR,
      error,
    });
  }
}
